export default "__VITE_ASSET__29f636ee__"